import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@uigy/app.module';
import { environment } from '@env/environment';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { AG_GRID_LICENSE_KEY } from '@uigy/shared/components/ui-grid/constants/ui-grid.constant';


if (environment.production) {
  enableProdMode();
}

LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err: any) => console.log(err));
